import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { GetImages } from "../../utils/GetImages";
import SelectLeaseAndUploader from "../common/SelectLeaseAndUploader";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { useError } from "../../utils/context/ErrorContext";
import { Form, Offcanvas } from "react-bootstrap";
import apiHelper from "../../utils/apiHelper";
import {
  DocumentEntityTypesEnum,
  DocumentService,
  DocumentTypesEnum,
  LeaseAgreementService,
  LeaseAgreementStatusTypesEnum,
  LeaseApplicationService,
  LeaseApplicationStatusTypesEnum,
  OrganizationService,
  TenantLeaseTypesEnum,
  TenantService,
} from "@propertelligent/client-api";
import AddTraspButton from "../firstTimeUserExperience/commonCom/AddTraspButton";
import UploadLeaseAgreement from "./common/UploadLeaseAgreement";
import UtilHelper from "../../utils/UtilHelper";
import LeaseAgreementSettings from "./LeaseAgreement/LeaseAgreementSettings";
import ProspectTenantCard from "../../newComponents/listings/listing-cards/prospect-tenant";
import StepProgress from "../TenantOnboard/component/StepProgress/StepProgress";
import LeftArrowTopHeader from "../../newComponents/form-fields/LeftArrowTopHeader";
import { utcDateFormat } from "../../utils/helper";
import {
  checkEmptyFieldsFunc,
  handleGenerateAndUploadPdf,
} from "../../utils/validateHelper";
import { NotificationType, PubSub, TopicsEnum } from "../../utils/pubsub";
import { useOnboardingContext } from "../../utils/context/OnboardingContext";
import ShowLeaseAgreement from "./LeaseAgreement/ShowLeaseAgreement";
import { useReactToPrint } from "react-to-print";
import StatusHeader from "../TenantOnboard/component/StatusHeader/StatusHeader";
import { ConfirmationPopup } from "../../newComponents/confirmation-popup/confirmation-popup-demo";
import PostPayment from "./landlordTenantOnboard/component/postpayment/PostPayment";
import SendReminder from "./SendReminder";
import DateHelper from "../../utils/DateHelper";
import LeaseOverlapModal from "../../newComponents/tenant/LeaseOverlapModal";
import FixedFooter from "../../newComponents/listings/add-listing-footer/fixed-footer";
import SimpleSpinner from "../../components/loader";
import OrganizationNameHeader from "../common/OrganizationNameHeader/OrganizationNameHeader";
import LoaderOverlay from "../common/LoaderOverlay";
import { UserLoginData } from "../common/charts/Enums";

interface RenewalLeaseProps {
  tenantData?: any;
  role?: "landlord" | "tenant";
}

const RenewalLease: React.FC<RenewalLeaseProps> = ({
  tenantData: propTenantData,
  role = "landlord",
}) => {
  const [selectLease, setSelectLease] = useState<string>("0");
  const [status, setStatus] = useState("");
  const [selectedOption, setSelectedOption] = useState(
    TenantLeaseTypesEnum.FixedTermLease,
  );
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [ForceUpdate, setForceUpdate] = useState(false);
  const [LeaseRenewalsErrorMessage, setLeaseRenewalsErrorMessage] =
    useState("");
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } =
    useError();
  const [leaseDetails, setLeaseDetails] = useState<any>({
    startDate: "",
    endDate: "",
    amount: "",
    securityDeposit: "",
  });
  const contentRef = useRef();
  const agreementRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const [selectOption, setSelectOption] = useState("Approved");
  const [tenantType, setTenantType] = useState(
    localStorage.getItem("TenantType"),
  );
  const [showModel, setShowModel] = useState(false);
  const [isPrint, setISPrint] = useState(false);
  const [agreementFileName, setAgreementFileName] = useState<any>("");
  const [uploadAgreement, setUploadAgreement] = useState<any>();
  const [uploadAgreementError, setUploadAgreementError] = useState(false);
  const [orgDetails, setOrgDetails] = useState<any>();

  // Use prop data if available, otherwise fetch later
  const [userData, setUserData] = useState<any>(propTenantData || undefined);

  const [selectedTemplateid, setSelectedTemplateid] = useState(
    propTenantData?.templateId || undefined,
  );
  const [showSignAgreeConfirm, setShowSignAgreeConfirm] = useState(false);
  const { id } = useParams();
  const { isSignatureConfirm } = useOnboardingContext();
  const [postLeaseAgreement, setPostLeaseAgreement] = useState({
    leaseAgreementId: propTenantData?.currentLeaseAgreementId || null,
    leaseAgreementStatus: null,
    leaseAgreementStatusTypeId: propTenantData?.leaseAgreementStatus || null,
    paymentDueAccountIds: null,
    tenantId: propTenantData?.id || id,
    unitId: propTenantData?.unitId || userData?.unitId,
    templateId: propTenantData?.templateId || selectedTemplateid || "",
    dataAttributes: {},
    tenantSignature: { fullName: "Tenant", signedDateTime: new Date() },
    landlordSignature: { fullName: "Landlord", signedDateTime: new Date() },
  });
  // const [formData, setFormData] = useState([{ id: 1, paymentType: "", amount: undefined, dueDate: "", gracePeriods: undefined, description: "" }]);

  const [isLeaseOverlapModalOpen, setIsLeaseOverlapModalOpen] = useState(false);
  const [existingLeaseData, setExistingLeaseData] = useState<any>({});
  const [isLoadingLeaseData, setIsLoadingLeaseData] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFetchExistingLease = (
    id: string | number,
    isId: boolean = false,
  ) => {
    setIsLoadingLeaseData(true);
    const serviceCall = isId
      ? LeaseAgreementService.getApiLeaseAgreement1
      : LeaseAgreementService.getApiLeaseAgreementUnitlist;

    apiHelper(
      serviceCall,
      { showNotification: false },
      Number(id),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    )
      .then((res) => {
        const data = res?.data?.success;
        const lease = Array.isArray(data) ? data[0] : data;
        setExistingLeaseData(lease?.formatted || {});
        setIsLoadingLeaseData(false);
      })
      .catch(() => {
        setIsLoadingLeaseData(false);
      });
  };

  const navigate = useNavigate();

  // Determine if we are in tenant view mode
  const isTenantView = role === "tenant";

  // Effect to update state when props change (specifically for tenantData)
  useEffect(() => {
    if (propTenantData) {
      setUserData(propTenantData);
      setTenantType("E Lease"); // Forced for tenant view usually
      setPostLeaseAgreement((prev) => ({
        ...prev,
        leaseAgreementId: propTenantData?.currentLeaseAgreementId,
        leaseAgreementStatusTypeId: propTenantData?.leaseAgreementStatus,
        tenantId: propTenantData?.id,
        unitId: propTenantData?.unitId,
        templateId: propTenantData?.templateId,
      }));
      setSelectedTemplateid(propTenantData?.templateId);
    }
  }, [propTenantData]);

  const checkEmptyFields = (): boolean => {
    let hasError = false;
    clearErrors();
    const newErrors = { ...errors };

    if (leaseDetails.startDate.trim() === "") {
      newErrors.startDate = true;
      hasError = true;
    }

    if (
      selectedOption === TenantLeaseTypesEnum.FixedTermLease &&
      leaseDetails.endDate.trim() === ""
    ) {
      newErrors.endDate = true;
      hasError = true;
    }

    if (!leaseDetails.amount) {
      newErrors.rent = true;
      hasError = true;
    }

    if (!leaseDetails.securityDeposit) {
      newErrors.securityDeposit = true;
      hasError = true;
    }
    if (!uploadAgreement) {
      setUploadAgreementError(true);
      hasError = true;
    } else {
      setUploadAgreementError(false);
    }
    setErrors(newErrors);
    setErrorMessages({
      ...errorMessages,
      ...(newErrors.rent ? { rent: "Rent is required" } : { rent: "" }),
      ...(newErrors.securityDeposit
        ? { securityDeposit: "Security Deposit is required" }
        : { securityDeposit: "" }),
      ...(newErrors.startDate ? { startDate: "Start Date is required" } : {}),
      ...(newErrors.endDate ? { endDate: "End Date is required" } : {}),
    });
    return hasError;
  };

  const getTenantsData = async () => {
    if (propTenantData) return;
    const tenantsResponse = await apiHelper(
      TenantService.getApiTenant1,
      { showNotification: false },
      Number(id),
    );

    if (tenantsResponse?.data?.success) {
      setUserData(tenantsResponse?.data?.success);
    }
  };

  const getOrgDetails = () => {
    apiHelper(
      TenantService.getApiTenantOrganizationHeaderInfo,
      { showNotification: false },
      id,
    )
      .then((res) => {
        if (res?.data?.success) setOrgDetails(res.data.success);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(
      TopicsEnum.RefreshLeaseData.toString(),
      () => {
        getTenantsData();
      },
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    getTenantsData();
    getOrgDetails();
  }, [
    userData?.currentLeaseAgreementId,
    postLeaseAgreement?.leaseAgreementStatusTypeId,
    showModel,
  ]);

  const leaseAgreementStepLabels = [
    "Send Agreement",
    "Tenant Signature",
    "Payments",
    "Landlord Signature",
  ];

  const getCompletedStepCount = (statusId?: number | string) => {
    if (!statusId) return 0;
    const status = Number(statusId);
    const hasTenantSigned =
      userData?.tenantSignature?.signedDateTime ||
      userData?.currentLeaseInfo?.tenantSignature?.signedDateTime ||
      postLeaseAgreement?.tenantSignature?.signedDateTime;

    if (status === LeaseAgreementStatusTypesEnum.RenewalInProgess) {
      if (hasTenantSigned && new Date(hasTenantSigned).getFullYear() > 1970)
        return 2;
      return 1;
    }
    if (status === LeaseAgreementStatusTypesEnum.PendingTenantSignature) {
      if (hasTenantSigned && new Date(hasTenantSigned).getFullYear() > 1970)
        return 2;
      return 1;
    }

    if (status === LeaseAgreementStatusTypesEnum.PendingPayment) return 2;
    if (status === LeaseAgreementStatusTypesEnum.PendingLandlordSignature)
      return 3;
    if (status === LeaseAgreementStatusTypesEnum.Signed) return 4;

    return 0;
  };

  const getLeaseAgreementSteps = (statusId?: number | string) => {
    const completedCount = getCompletedStepCount(statusId);
    return leaseAgreementStepLabels.map((label, idx) => ({
      label,
      completed: idx < completedCount,
    }));
  };

  const leaseAgreementSteps = useMemo(
    () =>
      getLeaseAgreementSteps(postLeaseAgreement?.leaseAgreementStatusTypeId),
    [postLeaseAgreement?.leaseAgreementStatusTypeId, role],
  );


  const formSubmitHandler = (
    event?: React.FormEvent,
    forceOverride: boolean = false,
  ) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    if (checkEmptyFields()) {
    } else {
      let formattedEndDate = null;
      const formattedStartDate = new Date(leaseDetails.startDate).toISOString();
      if (leaseDetails.endDate) {
        formattedEndDate = new Date(leaseDetails.endDate).toISOString();
      }

      const requestBody = {
        unitId: Number(userData?.unitId),
        tenantId: Number(id), // Note: This might be undefined in Tenant View, but this form is likely landlord only
        forceUpdate: forceOverride || ForceUpdate,

        leaseTypeId: Number(selectedOption),
        securityDeposit: Number(leaseDetails.securityDeposit),
        rent: Number(leaseDetails.amount),
        startDate: formattedStartDate,
        endDate: formattedEndDate,

        prevoiusLeaseAgreementId: userData?.currentLeaseAgreementId,
      };

      apiHelper(
        LeaseAgreementService.postApiLeaseAgreement,
        {
          successMessage: "Renew Lease Successfully",
          failureMessage: "Unable to Renew Lease",
          showNotification: true,
        },
        requestBody,
      )
        .then((res) => {
          if (res?.data?.success) {
            const leaseAgreementData = {
              EntityTypeId: DocumentEntityTypesEnum.Tenant,
              EntityId: userData?.id,
              DocumentTypeId: DocumentTypesEnum.LeaseAgreement,
              IsMain: false,
              FileName: agreementFileName,
              Document: uploadAgreement,
            };
            apiHelper(
              DocumentService.postApiDocument,
              { showNotification: false },
              leaseAgreementData,
            ).then((res1) => {
              if (res1?.data?.success) {
                setLeaseDetails({
                  startDate: "",
                  endDate: "",
                  amount: "",
                  securityDeposit: "",
                });
                setUploadAgreement(null);
                setAgreementFileName("");
                navigate(
                  `/tenants/currenttenantdetails/${userData?.id}/${userData?.unitId}`,
                );
              }
            });
          } else {
            if (res?.statusCode === 409) {
              const conflictEntityId = res?.errors?.ConflictEntityId?.[0];
              if (conflictEntityId && conflictEntityId !== "0") {
                handleFetchExistingLease(conflictEntityId, true);
                setIsLeaseOverlapModalOpen(true);
              } else {
                const errorMessage =
                  res?.errors?.leaseAgreementId?.[0] ||
                  res?.errors?.StartDate?.[0] ||
                  "A conflict occurred.";
                PubSub.publish(TopicsEnum.Notification.toString(), {
                  message: errorMessage,
                  type: NotificationType.Failure,
                });
              }
            } else if (res?.errors?.LeaseRenewals) {
              setShowConfirmation(true);
              setLeaseRenewalsErrorMessage(res.errors.LeaseRenewals[0]);
            }
          }
        })
        .catch((err) => {});
    }
  };


  const leaseAgreementCompletedCount = leaseAgreementSteps.filter(
    (s) => s.completed,
  ).length;
  const leaseAgreementProgress =
    leaseAgreementSteps.length > 0
      ? Math.round(
          (leaseAgreementCompletedCount / leaseAgreementSteps.length) * 100,
        )
      : 0;

  const SignLeaseAgreement = async () => {
    if (isSubmitting) return;

    let leaseData;
    let serviceCall;

    if (isTenantView) {
      leaseData = {
        fullName: postLeaseAgreement?.tenantSignature?.fullName,
        signedDateTime: new Date().toISOString(),
      };
      serviceCall = LeaseAgreementService.putApiLeaseAgreementTenantSignature;
    } else {
      leaseData = {
        fullName: postLeaseAgreement?.landlordSignature?.fullName,
        signedDateTime: postLeaseAgreement?.landlordSignature?.signedDateTime
          ? utcDateFormat(postLeaseAgreement.landlordSignature.signedDateTime)
          : utcDateFormat(new Date().toISOString()),
      };
      serviceCall = LeaseAgreementService.putApiLeaseAgreementLandlordSignature;
    }

    if (
      checkEmptyFieldsFunc(
        leaseData,
        clearErrors,
        errors,
        errorMessages,
        setErrors,
        setErrorMessages,
        undefined,
      )
    ) {
      setErrors({ ...errors, fullName: true });
      setErrorMessages({ ...errorMessages, fullName: "Full Name is required" });
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await apiHelper(
        serviceCall,
        {
          showNotification: true,
          successMessage: "Lease Agreement signed successfully",
          failureMessage: "Unable to sign Lease Agreement",
        },
        postLeaseAgreement?.leaseAgreementId,
        leaseData as any,
      );

      if (!response?.data?.success) {
        setIsSubmitting(false);
        return;
      }

      const signatureData =
        typeof response.data.success === "object" ? response.data.success : {};
      setPostLeaseAgreement((prev) => ({
        ...prev,
        landlordSignature: {
          ...prev.landlordSignature,
          ...leaseData,
          ...signatureData,
        },
      }));

      // Tenant flow ends here
      if (isTenantView) {
        PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
        navigate("/");
        setIsSubmitting(false);
        return;
      }

      // Wait for DOM paint
      await new Promise(requestAnimationFrame);

      if (!agreementRef.current) {
        console.error("Agreement ref is null. Cannot generate PDF.");
        setIsSubmitting(false);
        return;
      }

      await handleGenerateAndUploadPdf(
        setISPrint,
        agreementRef,
        async (blob) => {
          const file = new File(
            [blob],
            `LeaseAgreement-${userData?.firstName || "Signed"}.pdf`,
            { type: "application/pdf" },
          );

          const uploadData = {
            EntityTypeId: DocumentEntityTypesEnum.Tenant,
            EntityId: userData?.id,
            DocumentTypeId: DocumentTypesEnum.LeaseAgreement,
            IsMain: false,
            FileName: file.name,
            Document: file,
          };

          await apiHelper(
            DocumentService.postApiDocument,
            { showNotification: false },
            uploadData,
          );
        },
      );

      // Now refresh AFTER upload
      PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);

      navigate(
        `/tenants/currenttenantdetails/${userData?.id}/${userData?.unitId}`,
      );
    } catch (error) {
      console.error("Error during signing flow:", error);
    } finally {
      setIsSubmitting(false);
      setISPrint(false);
    }
  };

  let showAgreement =
    userData?.leaseAgreementStatus ===
    LeaseAgreementStatusTypesEnum.RenewalInProgess;
  if (isTenantView && userData) {
    showAgreement = true;
  }

  const handleActionClick = (actionLabel) => {
    if (actionLabel === "Post Payment") {
      setSelectOption("PostPayment");
      setShowModel(true);
    } else if (actionLabel === "Reject") {
      setSelectOption("Reject");
      setShowModel(true);
    } else if (actionLabel === "Approve") {
      setSelectOption("Approve");
      setShowModel(true);
    } else if (actionLabel == "Send Reminder") {
      setShowModel(true);
      setSelectOption("Reminder");
    } else if (actionLabel === "Sign Agreement") {
      const element = document.getElementById("signature-section");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
      // setStatus("submitted");
    }
  };
  useEffect(() => {
    const agreementStatus = postLeaseAgreement?.leaseAgreementStatusTypeId;
    if (!agreementStatus) return;
    else if (
      agreementStatus === LeaseAgreementStatusTypesEnum.PendingTenantSignature
    ) {
      setStatus("tenantSignaturePending");
    } else if (
      agreementStatus === LeaseAgreementStatusTypesEnum.PendingPayment
    ) {
      setStatus("leasePaymentPending");
    } else if (
      agreementStatus === LeaseAgreementStatusTypesEnum.PendingLandlordSignature
    ) {
      setStatus("landlordSignaturePending");
    } else if (agreementStatus === LeaseAgreementStatusTypesEnum.Signed) {
      setStatus("movein");
    } else {
      setStatus("unknown");
    }
  }, [postLeaseAgreement?.leaseAgreementStatusTypeId]);
  return (
    <>
      <>
        {/* Only show header info card if NOT tenant view, or customize for tenant */}
        {!isTenantView && (
          <div className={`tenant-card `}>
            <div className="tenant-card-header">
              <div className="tenant-avatar">
                <div className="tenant-initials">
                  {UtilHelper.getInitials(
                    userData?.firstName + " " + userData?.lastName,
                  )}
                </div>
              </div>
              <div className="tenant-details">
                <h3 className="tenant-name">
                  {userData?.firstName + " " + userData?.lastName}
                </h3>
                <p className="tenant-address">{userData?.streetAddress}</p>
                <p className="tenant-contact">
                  {userData?.email + " • " + userData?.formatted?.PhoneNumber}
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="leaseRenewHeader">
          <LeftArrowTopHeader
            title={`${tenantType == "E Lease" || isTenantView ? "Renew Lease" : tenantType}`}
            backPath={isTenantView ? "/" : -1}
          />
          {(tenantType == "E Lease" || isTenantView) && (
            <StatusHeader
              role={role}
              status={status}
              onActionClick={handleActionClick}
              disableApprove={false}
            />
          )}
        </div>
        {(tenantType === "E Lease" || isTenantView) && (
          <>
            <div className="tennatOnboardSection px-3">
              <div className="tenantOnboardSidebar">
                <div className="sidebar-panel">
                  <StepProgress
                    title="Lease Agreement"
                    steps={leaseAgreementSteps}
                    progress={leaseAgreementProgress}
                  />
                </div>
              </div>
              <div className="tenantOnboardContent">
                <div className="testonboard" data-theme={isPrint ? "light" : undefined}>
                  {showAgreement ? (
                    <div
                      data-theme={isPrint ? "light" : undefined}
                      className="LeaseAgreementContainer borderWithBorderRadious py-3"
                      ref={agreementRef}
                    >
                      {isPrint && (
                        <div className="d-flex flex-column gap-3 mb-3">
                          <div className="BackgroundWhite borderWithBorderRadious">
                            <OrganizationNameHeader
                              OrgName={orgDetails?.name}
                              OrgImg={
                                orgDetails?.logoImageBase64 !== "" &&
                                orgDetails?.logoImageBase64
                                  ? `data:image/*;base64,${orgDetails?.logoImageBase64}`
                                  : null
                              }
                              SubHeaderName={"Lease Agreement"}
                              element={<></>}
                            />
                          </div>
                        </div>
                      )}
                      <ShowLeaseAgreement
                        leaseApplicationId={undefined}
                        currentLeaseAgreementId={
                          userData?.currentLeaseAgreementId
                        }
                        isPreview={false}
                        userData={userData}
                        selectedTemplateid={selectedTemplateid}
                        postLeaseAgreement={postLeaseAgreement}
                        setPostLeaseAgreement={setPostLeaseAgreement}
                        orgDetails={orgDetails}
                        subHeaderName="Lease Agreement"
                        onClick={() => {
                          // Validation Logic here if needed or handled in SignLeaseAgreement
                          if (isTenantView) {
                            let leaseData = {
                              fullName:
                                postLeaseAgreement?.tenantSignature?.fullName,
                            };
                            if (
                              checkEmptyFieldsFunc(
                                leaseData,
                                clearErrors,
                                errors,
                                errorMessages,
                                setErrors,
                                setErrorMessages,
                                undefined,
                              )
                            ) {
                              setErrors({ ...errors, fullName: true });
                              setErrorMessages({
                                ...errorMessages,
                                fullName: "Full Name is required",
                              });
                              return;
                            }
                          }
                          setShowSignAgreeConfirm(true);
                        }}
                        onCancel={
                          () => undefined
                          //  setPreviewLeaseAgreement(false)
                        }
                        role={role}
                        buttonName={isTenantView ? "Sign Agreement" : ""} // Tenant sees "Sign Agreement", Landlord logic usually handled differently
                        selectedTemplates={undefined}
                        showHeader={false}
                        isLoading={isSubmitting}
                        isPrint={isPrint}
                      />
                    </div>
                  ) : (
                    <>
                      <LeaseAgreementSettings
                        userData={userData}
                        setIsPrint={setISPrint}
                        selectedTemplateid={selectedTemplateid}
                        setSelectedTemplateid={setSelectedTemplateid}
                        setPostLeaseAgreement={setPostLeaseAgreement}
                        postLeaseAgreement={postLeaseAgreement}
                        setPreviewLeaseAgreement={undefined}
                        // formData={formData} setFormData={setFormData}
                        leaseApplicationId={id}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {tenantType === "Upload Lease Agreement" && !isTenantView && (
          <>
            <form className="uploadLeaseAgreementForm" data-theme={isPrint ? "light" : undefined}>
              <div className="uploadLeaseAgreementContainer">
                <UploadLeaseAgreement
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                  values={leaseDetails}
                  setValues={setLeaseDetails}
                  uploadAgreement={uploadAgreement}
                  setUploadAgreement={setUploadAgreement}
                  agreementFileName={agreementFileName}
                  setAgreementFileName={setAgreementFileName}
                  isShowLeaseApplicationUploader={false}
                  uploadAgreementError={uploadAgreementError}
                  setUploadAgreementError={setUploadAgreementError}
                />
              </div>
              <div
                className="newTanentBottomBar gap-3"
                id="upload-lease-bottom"
              >
                <FixedFooter
                  onSubmit={() => setShowConfirmation(true)}
                  buttonLabel="Renew Lease"
                  loading={false}
                  onCancel={() => navigate(-1)}
                />
              </div>
            </form>
          </>
        )}
      </>

      <Offcanvas
        className="offcanvas serviceRequestForm"
        show={showModel}
        onHide={() => setShowModel(false)}
        placement={"end"}
        scroll={true}
      >
        <Offcanvas.Header className="canvasHeader" closeButton>
          <Offcanvas.Title>
            {selectOption == "PostPayment"
              ? "Post Payment"
              : `${selectOption} Application`}{" "}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {selectOption === "Reminder" ? (
            <SendReminder />
          ) : selectOption == "PostPayment" ? (
            <PostPayment
              data={{
                firstName: userData?.firstName,
                lastName: userData?.lastName,
                fullName: userData?.fullName,
                amount:
                  userData?.leaseApplicationTemplateSections?.ApplicationFees
                    ?.fee,
              }}
              tenantId={userData?.id}
              setShowModel={setShowModel}
              feestype={"Agreement Fees"}
              payDueAccountId={postLeaseAgreement?.paymentDueAccountIds}
            />
          ) : null}
        </Offcanvas.Body>
      </Offcanvas>

      {showConfirmation && (
        <ConfirmationPopup
          isOpen={true}
          title="Create Lease Agreement Forcefully"
          message="Are you sure you want to Send  Agreement?"
          primaryButtonLabel="No"
          secondaryButtonLabel="Yes"
          onPrimaryAction={() => setShowConfirmation(false)}
          onSecondaryAction={() => {
            setForceUpdate(true);
            setShowConfirmation(false);
            formSubmitHandler(); // <-- your function will be called here
          }}
          onClose={() => {
            setForceUpdate(false);
            setShowConfirmation(false);
          }}
          isPrimaryAction={false}
          isPrimaryDestructive={false}
        />
      )}

      {isLeaseOverlapModalOpen && (
        <LeaseOverlapModal
          isOpen={isLeaseOverlapModalOpen}
          onClose={() => {
            setIsLeaseOverlapModalOpen(false);
            setForceUpdate(false);
          }}
          onContinue={() => {
            setForceUpdate(true);
            // setIsLeaseOverlapModalOpen(false);
            formSubmitHandler(undefined, true);
          }}
          existingLease={{
            type: existingLeaseData?.LeaseTypeId,
            startDate: existingLeaseData?.StartDateDateOnly,
            endDate: existingLeaseData?.EndDateDateOnly,
            securityDeposit: existingLeaseData?.SecurityDeposit,
            securityDepositRaw: existingLeaseData?.SecurityDepositRaw,
            rent: existingLeaseData?.Rent,
            rentRaw: existingLeaseData?.RentRaw,
          }}
          newLeaseEndDate={DateHelper.getPreviousDay(leaseDetails.startDate)}
          isLoading={isLoadingLeaseData}
        />
      )}

      {showSignAgreeConfirm && (
        <ConfirmationPopup
          isOpen={true}
          title="Confirm Signature"
          message="Are you sure you want to Sign Agreement?"
          primaryButtonLabel="No"
          secondaryButtonLabel={
            isSubmitting ? <SimpleSpinner myClassName="Icon16" /> : "Yes"
          }
          onPrimaryAction={() =>
            !isSubmitting && setShowSignAgreeConfirm(false)
          }
          onSecondaryAction={() => {
            if (!isSubmitting) {
              SignLeaseAgreement();
            }
          }}
          onClose={() => !isSubmitting && setShowSignAgreeConfirm(false)}
          isPrimaryAction={false}
          isPrimaryDestructive={false}
        />
      )}

      {isSubmitting && <LoaderOverlay message="Finalizing your signature..." />}
    </>
  );
};
export default RenewalLease;
